const TS_CONFIG_FILENAME = "tsconfig.json";
export {
  TS_CONFIG_FILENAME
};
//# sourceMappingURL=TS_CONFIG_FILENAME.js.map
